import React from "react";
import CloseIcon from "~/assets/icons/close.svg";
import s from "./CloseButton.module.scss";

interface Props {
  onClose: () => void;
}

const CloseButton: React.FC<Props> = ({ onClose }) => {
  return (
    <button className={s.closeBtn} onClick={onClose}>
      <img src={CloseIcon} />
    </button>
  );
};

export default CloseButton;
